import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class ConnectEngineCriteria extends BasicCriteria {
engineType: string;
visionCode: string;
}

